import cn from 'classnames';
import Image from 'next/legacy/image';
import { Grid, Icon } from 'ht-styleguide';
import { TechInfoProps } from '../locationPage.types';
import styles from '../locationPage.module.scss';

type TechProps = {
  title?: string;
  locationOrCategory: string;
};

const techData: TechInfoProps[] = [
  {
    techFirstName: 'Ticia',
    techLastNameInitials: 'H',
    techRating: 4.7,
    techState: '', // San Francisco-Oakland-Berkeley CA
    techJobCount: 43,
    techImage: '/_nextassets_/images/locationPages/techs/1.jpg',
  },
  {
    techFirstName: 'Rick',
    techLastNameInitials: 'L',
    techRating: 4.9,
    techState: '', // Atlanta-Sandy Springs-Alpharetta GA
    techJobCount: 480,
    techImage: '/_nextassets_/images/locationPages/techs/2.jpg',
  },
  {
    techFirstName: 'Nathanael',
    techLastNameInitials: 'H',
    techRating: 4.9,
    techState: '', // Portland-Vancouver-Hillsboro OR-WA
    techJobCount: 1599,
    techImage: '/_nextassets_/images/locationPages/techs/3.jpg',
  },
];

const TechInfoBlock = ({ title = 'Meet some of our local', locationOrCategory }: TechProps) => (
  <section className={cn('paddingY-huge', styles.techInfoContainer)}>
    <Grid.Fluid>
      <Grid.Row classes="paddingBottom-huge1">
        <Grid.Column mdOffset={2} md={4} lgOffset={0} lg={12}>
          <h3 className="text-align-center">
            {title} {locationOrCategory} specialists
          </h3>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        {techData?.map((tech: TechInfoProps) => {
          const imgAlt = `Photo of ${tech.techFirstName}, a HelloTech Technician`;
          return (
            <Grid.Column sm={4} md={8} lg={4} key={tech.techFirstName} classes={styles.techDetails}>
              <div className={styles.techAvatar}>
                <Image quality={70} layout="fill" src={tech.techImage} alt={imgAlt} />
              </div>
              <h5 className="paddingTop-small1">
                {tech.techFirstName} {tech.techLastNameInitials}.
              </h5>
              <div className="flex justifyContentCenter alignItemsCenter paddingTop-small">
                <Icon className="p2 paddingRight-tiny" name="v2-star" />
                <p className="p2">{tech.techRating}</p>
                <p className="p2 paddingX-small lightBlue700">|</p>
                <p className="p2">{tech.techJobCount} Jobs</p>
              </div>
            </Grid.Column>
          );
        })}
      </Grid.Row>
    </Grid.Fluid>
  </section>
);

export default TechInfoBlock;
